import { ConfigurationDataProps, FOUNDATION_ENDPOINTS, FOUNDATION_ROUTES, ProviderAccreditationConfigurationService, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { ConfigurationService, HttpService, LocaleService, MessageService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationContext, foundationContext, Information } from '@philips-emr/tws-foundation/lib/context';

import { setupModules } from './modules';

interface Theme {
  dsColorRange: ThemeColor;
  dsAccentColor: ThemeColor;
  dsNavTonalRange: ThemeTonalRange;
  dsLoginTonalRange: ThemeTonalRange;
}

function map(obj: object): Information {
  const { body } = obj as any;

  return body;
}

export function bootstrap(): Promise<void> {
  applicationContext.setTitle(MessageService.msg('pa.application-name'));
  foundationContext.setCanEditSector(false);
  foundationContext.setCanEditProfile(false);
  foundationContext.setCanEditEstablishment(false);
  foundationContext.setShowEstablishment(false);
  foundationContext.setShowSector(false);

  ConfigurationService.setAuthenticationConfiguration({
    clientId: 'providerAccreditation',
    endpointMappers: {
      // @ts-ignore
      information: map,
    },
    endpoints: {
      information: {
        url: FOUNDATION_ENDPOINTS.INFORMATION,
        method: HttpMethod.GET,
      },
      refresh: {
        url: FOUNDATION_ENDPOINTS.REFRESH,
        method: HttpMethod.POST,
      },
      revoke: {
        url: FOUNDATION_ENDPOINTS.REVOKE,
        method: HttpMethod.POST,
      },
    },
    inactivity: {
      time: 15 * 60 * 1000,
    },
    routes: {
      custom: [
        FOUNDATION_ROUTES.NEW_PW,
        FOUNDATION_ROUTES.CONFIRM_USER_NEW_PW,
        Route.NEW_USER_CONFIRMATION,
        Route.PRIVACY_WARNING,
        Route.TERM_OF_USE,
        Route.NEW_USER_CONFIRMATION,
        FOUNDATION_ROUTES.RENEW_PW_BY_USERNAME,
      ],
      forgotPassword: FOUNDATION_ROUTES.FORGOT_PW,
      home: FOUNDATION_ROUTES.REDIRECT,
      inactivity: FOUNDATION_ROUTES.INACTIVITY,
      login: FOUNDATION_ROUTES.LOGIN,
    },
  });

  setupModules();

  const themePromise = HttpService.get(FOUNDATION_ENDPOINTS.THEME)
    .then(response => {
      let { dsColorRange, dsAccentColor, dsNavTonalRange, dsLoginTonalRange } = response.body as Theme;

      dsColorRange = dsColorRange || ThemeColor.GREEN;
      dsAccentColor = dsAccentColor || ThemeColor.AQUA;
      dsLoginTonalRange = dsLoginTonalRange || ThemeTonalRange.ULTRA_LIGHT;
      dsNavTonalRange = dsNavTonalRange || ThemeTonalRange.BRIGHT;

      ThemeService.setColors(dsColorRange, dsAccentColor as any);
      ThemeService.setContentTonalRange(dsLoginTonalRange);
      ThemeService.setNavigationTonalRange(dsNavTonalRange);
      ProviderAccreditationConfigurationService.setTonalidadeLogin(dsLoginTonalRange);

      return response.body as ConfigurationDataProps;
    });

  LocaleService.init({ defaultLocale: 'pt-BR', supportedLocales: ['pt-BR'] });

  ProviderAccreditationConfigurationService.setFileuploaderConfig();
  ProviderAccreditationConfigurationService.setConfigurationData(themePromise);

  return Promise.all([themePromise]).then(() => Promise.resolve());
}
